module.exports = __webpack_public_path__ + "static/img/pdf.85318abe.png";